import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import ReportsTable from "../../components/reports/ReportsTable";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useReports from "../../data/useReports";

export default function Reports() {
  const { t } = useTranslation("reports");
  const { setInfo } = usePageNameContext();
  const { reports } = useReports();

  useEffect(() => {
    setInfo({
      name: t("Reports"),
      desc: t("View and download reports"),
    });
  }, [setInfo, t]);

  if (reports.isLoading) {
    return <LoadingWheel />;
  }

  return (
    <ReportsTable data={reports.data?.data || []} />
  );
}